// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color-scheme: dark;
  --bg: #0f1115;
  --panel: #171a21;
  --text: #f4f7fb;
  --muted: #a6b0c2;
  --accent: #c3a9e9;
  --danger: #fb7185;
  --border: rgba(255, 255, 255, 0.08);
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  min-height: 100%;
}

body {
  font-family:
    system-ui,
    -apple-system,
    'Segoe UI',
    Arial,
    Helvetica,
    sans-serif;
  background: var(--bg);
  color: var(--text);
  padding: 16px;
  padding-bottom: max(16px, env(safe-area-inset-bottom));
  -webkit-text-size-adjust: 100%;
}

.app-root {
  width: min(100%, 980px);
  margin: 0 auto;
}

.app-title {
  font-size: clamp(24px, 4vw, 36px);
  margin: 0 0 8px;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: var(--text);
}

p.lead {
  margin: 0 0 16px;
  color: var(--muted);
  line-height: 1.55;
  font-size: 15px;
}

.panel {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
}

.viewer {
  position: relative;
  width: 100%;
  /** Etwas höher als zuvor (2:1) — mehr Bildfläche */
  aspect-ratio: 3 / 2;
  background: #000;
}

/* Video nicht display:none — iOS Safari braucht sichtbares Element im Layout */
.video-feed {
  position: absolute;
  inset: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  pointer-events: none;
}

.overlay-canvas {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.scan-guide {
  position: absolute;
  z-index: 2;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 86%;
  height: 40%;
  border: 2px solid var(--accent);
  border-radius: 14px;
  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.12);
  pointer-events: none;
}

.status-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 12px 14px;
  border-top: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.02);
}

.status-bar--bottom {
  margin-top: 16px;
  border-top: none;
  border: 1px solid var(--border);
  border-radius: 16px;
  background: var(--panel);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.status-bar--bottom .status-bar-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.status-bar-footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-shrink: 0;
  margin-left: auto;
}

.status-bar--bottom .status-bar-api-btn,
.status-bar--bottom .status-bar-camera-btn {
  flex-shrink: 0;
  padding: 6px 10px;
  min-height: 36px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 9px;
}

@media (max-width: 640px) {
  .status-bar--bottom {
    flex-direction: column;
    align-items: stretch;
  }

  .status-bar--bottom .status-bar-pills {
    width: 100%;
    flex: none;
    min-width: 0;
  }

  .status-bar-footer-actions {
    width: 100%;
    margin-left: 0;
    flex-shrink: 1;
    justify-content: flex-start;
  }
}

.pill {
  border: 1px solid var(--border);
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 13px;
  color: var(--muted);
  background: rgba(255, 255, 255, 0.03);
  line-height: 1.3;
}

.controls {
  display: flex;
  gap: 10px;
  padding: 16px;
  flex-wrap: wrap;
  align-items: center;
}

button {
  appearance: none;
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  min-height: 40px;
}

button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.primary {
  background: var(--accent);
  color: #07130b;
}

.secondary {
  background: #293041;
  color: var(--text);
}

.result {
  margin-top: 16px;
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 16px;
}

.result-barcode {
  font-size: clamp(17px, 3vw, 22px);
  font-weight: 700;
  margin: 0 0 10px;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: var(--text);
  word-break: break-word;
}

.result-title {
  font-size: clamp(22px, 4.2vw, 34px);
  font-weight: 800;
  margin: 0 0 12px;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--text);
  word-break: break-word;
}

.result-attr-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin: 0 0 10px;
}

.pill--shelf {
  background: #22c55e;
  color: #000;
  border-color: #16a34a;
  font-weight: 700;
  font-size: 14px;
  padding: 7px 12px;
}

.result-article-number {
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
  margin: 0 0 4px;
  word-break: break-word;
}

.result-main {
  display: flex;
  gap: 14px;
  align-items: flex-start;
}

.result-main-text {
  flex: 1;
  min-width: 0;
}

.result-thumb-wrap {
  flex-shrink: 0;
}

.result-thumb {
  width: 96px;
  height: 96px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.04);
  display: block;
}

.result-thumb--placeholder {
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
}

@media (max-width: 480px) {
  .result-thumb,
  .result-thumb--placeholder {
    width: 72px;
    height: 72px;
  }
}

.result-footer {
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid var(--border);
}

.result .meta {
  margin-top: 6px;
  color: var(--muted);
  font-size: 14px;
  min-height: 20px;
  line-height: 1.45;
}

.result .meta--footer {
  font-size: 12px;
  color: var(--muted);
  opacity: 0.8;
  margin-top: 4px;
  min-height: 0;
}

.error {
  color: var(--danger);
  white-space: pre-wrap;
}

.login-panel {
  background: var(--panel);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 16px;
  max-width: 420px;
}

.login-panel label {
  display: block;
  font-size: 13px;
  color: var(--muted);
  margin-bottom: 6px;
}

.login-panel input {
  width: 100%;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.04);
  color: var(--text);
  padding: 12px 12px;
  font-size: 16px;
  margin-bottom: 12px;
  min-height: 44px;
}

.app-header-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: nowrap;
  margin-bottom: 8px;
}

.app-header-main {
  flex: 1;
  min-width: 0;
}

.app-header-actions {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.btn-header-logout {
  padding: 6px 10px;
  min-height: 36px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  border-radius: 9px;
}

.muted {
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/assets/global.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;;;;;;cAMY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,sDAAsD;EACtD,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,+EAA+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,UAAU;EACV,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,wBAAwB;EACxB,yCAAyC;EACzC,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,2BAA2B;EAC7B;AACF;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE;iFAC+E;AACjF;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[":root {\r\n  color-scheme: dark;\r\n  --bg: #0f1115;\r\n  --panel: #171a21;\r\n  --text: #f4f7fb;\r\n  --muted: #a6b0c2;\r\n  --accent: #c3a9e9;\r\n  --danger: #fb7185;\r\n  --border: rgba(255, 255, 255, 0.08);\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  margin: 0;\r\n  min-height: 100%;\r\n}\r\n\r\nbody {\r\n  font-family:\r\n    system-ui,\r\n    -apple-system,\r\n    'Segoe UI',\r\n    Arial,\r\n    Helvetica,\r\n    sans-serif;\r\n  background: var(--bg);\r\n  color: var(--text);\r\n  padding: 16px;\r\n  padding-bottom: max(16px, env(safe-area-inset-bottom));\r\n  -webkit-text-size-adjust: 100%;\r\n}\r\n\r\n.app-root {\r\n  width: min(100%, 980px);\r\n  margin: 0 auto;\r\n}\r\n\r\n.app-title {\r\n  font-size: clamp(24px, 4vw, 36px);\r\n  margin: 0 0 8px;\r\n  font-weight: 800;\r\n  letter-spacing: -0.02em;\r\n  color: var(--text);\r\n}\r\n\r\np.lead {\r\n  margin: 0 0 16px;\r\n  color: var(--muted);\r\n  line-height: 1.55;\r\n  font-size: 15px;\r\n}\r\n\r\n.panel {\r\n  background: var(--panel);\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\r\n}\r\n\r\n.viewer {\r\n  position: relative;\r\n  width: 100%;\r\n  /** Etwas höher als zuvor (2:1) — mehr Bildfläche */\r\n  aspect-ratio: 3 / 2;\r\n  background: #000;\r\n}\r\n\r\n/* Video nicht display:none — iOS Safari braucht sichtbares Element im Layout */\r\n.video-feed {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n}\r\n\r\n.overlay-canvas {\r\n  position: absolute;\r\n  inset: 0;\r\n  z-index: 1;\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  object-position: center;\r\n}\r\n\r\n.scan-guide {\r\n  position: absolute;\r\n  z-index: 2;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 86%;\r\n  height: 40%;\r\n  border: 2px solid var(--accent);\r\n  border-radius: 14px;\r\n  box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.12);\r\n  pointer-events: none;\r\n}\r\n\r\n.status-bar {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  padding: 12px 14px;\r\n  border-top: 1px solid var(--border);\r\n  background: rgba(255, 255, 255, 0.02);\r\n}\r\n\r\n.status-bar--bottom {\r\n  margin-top: 16px;\r\n  border-top: none;\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  background: var(--panel);\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);\r\n  justify-content: flex-start;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.status-bar--bottom .status-bar-pills {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.status-bar-footer-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  flex-shrink: 0;\r\n  margin-left: auto;\r\n}\r\n\r\n.status-bar--bottom .status-bar-api-btn,\r\n.status-bar--bottom .status-bar-camera-btn {\r\n  flex-shrink: 0;\r\n  padding: 6px 10px;\r\n  min-height: 36px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  border-radius: 9px;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .status-bar--bottom {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .status-bar--bottom .status-bar-pills {\r\n    width: 100%;\r\n    flex: none;\r\n    min-width: 0;\r\n  }\r\n\r\n  .status-bar-footer-actions {\r\n    width: 100%;\r\n    margin-left: 0;\r\n    flex-shrink: 1;\r\n    justify-content: flex-start;\r\n  }\r\n}\r\n\r\n.pill {\r\n  border: 1px solid var(--border);\r\n  border-radius: 999px;\r\n  padding: 6px 10px;\r\n  font-size: 13px;\r\n  color: var(--muted);\r\n  background: rgba(255, 255, 255, 0.03);\r\n  line-height: 1.3;\r\n}\r\n\r\n.controls {\r\n  display: flex;\r\n  gap: 10px;\r\n  padding: 16px;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n}\r\n\r\nbutton {\r\n  appearance: none;\r\n  border: 0;\r\n  border-radius: 10px;\r\n  padding: 10px 14px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  min-height: 40px;\r\n}\r\n\r\nbutton:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.primary {\r\n  background: var(--accent);\r\n  color: #07130b;\r\n}\r\n\r\n.secondary {\r\n  background: #293041;\r\n  color: var(--text);\r\n}\r\n\r\n.result {\r\n  margin-top: 16px;\r\n  background: var(--panel);\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n}\r\n\r\n.result-barcode {\r\n  font-size: clamp(17px, 3vw, 22px);\r\n  font-weight: 700;\r\n  margin: 0 0 10px;\r\n  line-height: 1.25;\r\n  letter-spacing: -0.01em;\r\n  color: var(--text);\r\n  word-break: break-word;\r\n}\r\n\r\n.result-title {\r\n  font-size: clamp(22px, 4.2vw, 34px);\r\n  font-weight: 800;\r\n  margin: 0 0 12px;\r\n  line-height: 1.2;\r\n  letter-spacing: -0.02em;\r\n  color: var(--text);\r\n  word-break: break-word;\r\n}\r\n\r\n.result-attr-pills {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  align-items: center;\r\n  margin: 0 0 10px;\r\n}\r\n\r\n.pill--shelf {\r\n  background: #22c55e;\r\n  color: #000;\r\n  border-color: #16a34a;\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n  padding: 7px 12px;\r\n}\r\n\r\n.result-article-number {\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  color: var(--text);\r\n  margin: 0 0 4px;\r\n  word-break: break-word;\r\n}\r\n\r\n.result-main {\r\n  display: flex;\r\n  gap: 14px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.result-main-text {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.result-thumb-wrap {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.result-thumb {\r\n  width: 96px;\r\n  height: 96px;\r\n  object-fit: cover;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  background: rgba(255, 255, 255, 0.04);\r\n  display: block;\r\n}\r\n\r\n.result-thumb--placeholder {\r\n  background:\r\n    linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .result-thumb,\r\n  .result-thumb--placeholder {\r\n    width: 72px;\r\n    height: 72px;\r\n  }\r\n}\r\n\r\n.result-footer {\r\n  margin-top: 14px;\r\n  padding-top: 10px;\r\n  border-top: 1px solid var(--border);\r\n}\r\n\r\n.result .meta {\r\n  margin-top: 6px;\r\n  color: var(--muted);\r\n  font-size: 14px;\r\n  min-height: 20px;\r\n  line-height: 1.45;\r\n}\r\n\r\n.result .meta--footer {\r\n  font-size: 12px;\r\n  color: var(--muted);\r\n  opacity: 0.8;\r\n  margin-top: 4px;\r\n  min-height: 0;\r\n}\r\n\r\n.error {\r\n  color: var(--danger);\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.login-panel {\r\n  background: var(--panel);\r\n  border: 1px solid var(--border);\r\n  border-radius: 16px;\r\n  padding: 16px;\r\n  max-width: 420px;\r\n}\r\n\r\n.login-panel label {\r\n  display: block;\r\n  font-size: 13px;\r\n  color: var(--muted);\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.login-panel input {\r\n  width: 100%;\r\n  border-radius: 12px;\r\n  border: 1px solid var(--border);\r\n  background: rgba(255, 255, 255, 0.04);\r\n  color: var(--text);\r\n  padding: 12px 12px;\r\n  font-size: 16px;\r\n  margin-bottom: 12px;\r\n  min-height: 44px;\r\n}\r\n\r\n.app-header-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n  flex-wrap: nowrap;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.app-header-main {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.app-header-actions {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding-top: 2px;\r\n}\r\n\r\n.btn-header-logout {\r\n  padding: 6px 10px;\r\n  min-height: 36px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n  border-radius: 9px;\r\n}\r\n\r\n.muted {\r\n  color: var(--muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
